<div *ngIf="tempChildKey == 'weekly_reporting'" class="reporting-main">
  <!-- <loading *ngIf="isLoading" class="reporting-loader"></loading> -->
  <div class="system-report-header" *ngIf="!isLoading">
    <label class="mb-0"> Date : </label>
    <p-calendar [disabledDays]="[0,2,3,4,5,6]" [maxDate]="now" [readonlyInput]="true" [minDate]="minDate" [(ngModel)]="startDate" 
      dateFormat="mm/dd/yy" [defaultDate]="startDate" [showTime]="false"></p-calendar>
    <div class="system-report-btn">
      <button type="button" [disabled]="!startDate || isLoading" (click)="onSearchWeeklyReport()" class="custom-button">Display</button>
      <button type="button" [disabled]="!startDate || isLoading"  (click)="onGenerateReport()" class="custom-button">Download Excel</button>
     </div>
     <!-- <div class="spinner">
      <span *ngIf="isLoading"><i class="fa fa-spinner fa-spin"></i></span>
     </div> -->
  </div>
  <div *ngIf="!isLoading">
    <div *ngIf="!isReportSearch" class="weeklyreport-nodata">
      <div class="no-data-content">
        <img src="./assets/images/alert.svg" alt="alert-icon" class="alert-icon">
        <p class="nodata-text">Please select date and search to display the data</p>
      </div>
    </div>
    <div *ngIf="isReportSearch">
      <div class="weekly-report-daterange">
       <span class="f-w-bold weekly-report-dateformat"> Date Range :</span>
        <div class="start-end-range">
          {{startDateReport}} - {{endDateReport}}
        </div>
      </div>
      <table class="width-hundred">
        <thead class="system-report-border">
          <tr class="system-report-border">
            <th class="system-report-border systemreport-right-border text-center">
              Sales Reps
            </th>
            <th class="system-report-border text-center">
              MONDAY
            </th>
            <th class="system-report-border text-center">
              TUESDAY
            </th>
            <th class="system-report-border text-center">
              WEDNESDAY
            </th>
            <th class="system-report-border text-center">
              THURSDAY
            </th>
            <th class="system-report-border text-center">
              FRIDAY
            </th>
            <th class="system-report-border text-center">
              SATURDAY
            </th>
            <th class="system-report-border text-center">
              WEEKLY TOTALS
            </th>
          </tr>
        </thead>
        <tr class="system-report-border">
          <td class="system-report-border f-w-bold systemreport-right-border system-report-green-bg">
            Totals
          </td>
          <td class="system-report-border system-report-green-bg">
            <dynamic-value [type]="'currency'" [class]="'f-w-bold'" [value]="totalWeek.totalMonday"></dynamic-value>
          </td>
          <td class="system-report-border system-report-green-bg">
            <dynamic-value [type]="'currency'" [class]="'f-w-bold'" [value]="totalWeek?.totalTuesday"></dynamic-value>
          </td>
          <td class="system-report-border system-report-green-bg">
            <dynamic-value [type]="'currency'" [class]="'f-w-bold'" [value]="totalWeek?.totalWednesday"></dynamic-value>
          </td>
          <td class="system-report-border system-report-green-bg">
            <dynamic-value [type]="'currency'" [class]="'f-w-bold'" [value]="totalWeek?.totalThursday"></dynamic-value>
          </td>
          <td class="system-report-border system-report-green-bg">
            <dynamic-value [type]="'currency'" [class]="'f-w-bold'" [value]="totalWeek?.totalFriday"></dynamic-value>
          </td>
          <td class="system-report-border system-report-green-bg">
            <dynamic-value [type]="'currency'" [class]="'f-w-bold'" [value]="totalWeek?.totalSaturday"></dynamic-value>
          </td>
          <td class="system-report-border system-report-green-bg">
            <dynamic-value [type]="'currency'" [class]="'f-w-bold'" [value]="totalWeek?.total"></dynamic-value>
          </td>
        </tr>
        <tbody *ngIf="reportData.length > 0" class="system-report-border">
          <tr *ngFor="let report of reportData" class="system-report-border">
            <td class="system-report-border systemreport-right-border">
              <dynamic-value [type]="'text'" [class]="'f-w-bold '" [value]="report?.assignedToName"></dynamic-value>
            </td>
            <td class="system-report-border">
              <dynamic-value [type]="'currency'" [value]="report?.monday"></dynamic-value>
            </td>
            <td class="system-report-border">
              <dynamic-value [type]="'currency'" [value]="report?.tuesday"></dynamic-value>
            </td>
            <td class="system-report-border">
              <dynamic-value [type]="'currency'" [value]="report?.wednesday"></dynamic-value>
            </td>
            <td class="system-report-border">
              <dynamic-value [type]="'currency'" [value]="report?.thursday"></dynamic-value>
            </td>
            <td class="system-report-border">
              <dynamic-value [type]="'currency'" [value]="report?.friday"></dynamic-value>
            </td>
            <td class="system-report-border">
              <dynamic-value [type]="'currency'" [value]="report?.saturday"></dynamic-value>
            </td>
            <td class="system-report-border system-report-green-bg">
              <dynamic-value [class]="'f-w-bold'" [type]="'currency'" [value]="report?.monday + report?.tuesday + report?.wednesday + report?.thursday + report?.friday + report?.saturday"></dynamic-value>
            </td>
          </tr>
        </tbody>
      </table>
  
    </div>
  </div>
  </div>
  <div *ngIf="tempChildKey !== 'weekly_reporting'">
    <div *ngIf="!isDataLoaded && params.status === 8" class="weeklyreport-nodata">
      <div class="no-data-content">
        <img src="./assets/images/alert.svg" alt="alert-icon" class="alert-icon">
        <p class="nodata-text">Please select Assigned Rep(s) to display orders</p>
      </div>
    </div>
    <div class="ui-fluid" *ngIf="isDataLoaded || params.status !== 8">
      <p-table #dt
               [value]="model.rows"
               [globalFilterFields]="filterableColumnKeys"
               [(selection)]="selectedRows"
               selectionMode="single"
               [lazy]="true"
               [loading]="false"
               [loadingIcon]="null"
               [showLoader]="false"
               (onLazyLoad)="lazyLoad($event)"
               [paginator]="false"
               [rows]="rows"
               [totalRecords]="rowCount"
               sortMode="multiple"
               [multiSortMeta]="multiSortMeta"
               [resizableColumns]="true"
               columnResizeMode="expand"
               (onRowSelect)="rowChangePreview($event.data.guid)"
               (onRowUnselect)="rowChangePreview($event.data.guid)"
               class="table-layout-fixed">
        <ng-template pTemplate="header">
          <tr class="order-list-header">
            <th id="order-list-width" [ngClass]="isShowCheckBox ? 'bulk-order-list-width' : 'order-list-width'" [attr.width]="rowTools.width" [style.min-width]="rowTools.width" [class.bulk-upload-width]="isShowCheckBox"></th>
            <th id="order-list-sortable" *ngFor="let col of visibleColumns" [pSortableColumn]="col.sortable ? col.key : null" [style.width.px]="col.width" [style.min-width.px]="col.width">
              <table>
                <th id="order-list-name" class="th-display-none"></th>
                <tbody>
                  <tr>
                    <td style="width:22px">
                      <p-sortIconCustom *ngIf="col.sortable === true" [field]="col.key"></p-sortIconCustom>
                    </td>
                    <td>
                      {{col.name}}
                    </td>
                  </tr>
                </tbody>
              </table>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="loadingbody" let-columns>
          <tr>
            <td [attr.colspan]="numColumns" style="text-align: center">
             <loading></loading>Loading...
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="numColumns" style="text-align: center">
              No records found
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item let-i="rowIndex">
          <!-- <tr [pSelectableRow]="item" -->
          <tr
              [style.background-color]="rowColor(item)"
              (mouseenter)="hover = item.id"
              (mouseleave)="hover = null">
            <td class="overflow-hidden">
              <div class="d-flex">
                <row-tools [tools]="rowTools"
                  [class]="( (item.colourCode && !item.colourCodeStatusOIP) || (item.oipColourCode && item.colourCodeStatusOIP)) ? 'link-btn' : 'table-order-number'"
                  [item]="item" (onSetRowColour)="setRowColour($event)" (onClick)="clickRowTools($event)"
                  [visible]="hover == item.id"></row-tools>
                <div class="bulk-upload-checkbox ml-auto">
                  @if (isShowCheckBox) {
                  <p-tableCheckbox [value]="item"
                    [disabled]="!item.isValidForDispatch || item.isBulkUploadActive || item.isEditModeActive"></p-tableCheckbox>
                  }
                  @if (hasUnlockPermission && (item.isBulkUploadActive || item.isEditModeActive) && params.status === 8) {
                  <i class="bi bi-person-fill-lock unlock-order-icon" aria-hidden="true" title="Unlock Order"
                    (click)="openUnlockConfirm(item)"></i>
                  }
                </div>
              </div>
            </td>
            <td *ngFor="let col of visibleColumns">
              <dynamic-value [class]="col.key == 'number' && ( (item.colourCode && !item.colourCodeStatusOIP) || (item.oipColourCode && item.colourCodeStatusOIP)) ? 'link-btn' : 'table-order-number'" [data]="item" [column]="col"></dynamic-value>
            </td>
          </tr>
        </ng-template>
      </p-table>
      <paginator-custom [rows]="dt.rows" [totalRecords]="dt.totalRecords" (onPageChange)="lazyLoad($event)"></paginator-custom>
    </div>
  </div>
  <p-dialog [style]="{width: '100vw',padding:'15px',border:'none',maxHeight:'100%', boxShadow:'none'}" #orderDialog [(visible)]="showModal" [modal]="true" [showHeader]="false" [closable]="false" appendTo="body">
    <order-form *ngIf="showModal && dialogRef != null" [dialog]="dialogRef" [id]="selection?.guid" (onCancel)="cancel($event)" (onSaveComplete)="save($event)" (onRevert)="revert($event)"  class="order-form-alignment"></order-form>
  </p-dialog>
  <p-dialog [style]="{width: '100vw',padding:'15px',border:'none',maxHeight:'100%', boxShadow:'none'}" [(visible)]="showUserModal" [modal]="true" [showHeader]="false" [closable]="false" appendTo="body">
    <user-form *ngIf="showUserModal" [id]="null" (onCancel)="cancel()" (onSaveComplete)="cancel();"></user-form>
  </p-dialog>
  <p-dialog #locationDialog [(visible)]="showLocationModal" [style]="{width: '100vw',padding:'15px',border:'none',maxHeight:'100%', boxShadow:'none'}" [modal]="true" [showHeader]="false" [closable]="false" appendTo="body">
    <location-form *ngIf="showLocationModal" [id]="null" (onCancel)="cancel()"></location-form>
  </p-dialog>
  <p-dialog *ngIf="showBulkEditModal"  [(visible)]="showBulkEditModal" styleClass="p-dialog-width-bulkupload bulk-upload-window" [modal]="true" [showHeader]="false" [closable]="false" appendTo="body">
    <dynamic-bulk-upload [orders]="selectedRows" (onCancel)="cancel($event)" (onSaveComplete)="save($event)"></dynamic-bulk-upload>
  </p-dialog>
  <confirm-delete-dialog
    [visible]="showUnlockConfirm"
    [message]="'Are you sure you want to unlock this order?'"
    (confirm)="onUnlockConfirm($event)">
  </confirm-delete-dialog>
  